import React from "react";
import Skeleton from "react-loading-skeleton";
import { connect } from "react-redux";
import {
  getCategory,
  getWorkshopsAddonByVariant,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
} from "../../../redux/actions/apiActions";
import {
  addToCart,
  setCartJobItems,
  setCartStage,
  setCartWorkshop,
} from "../../../redux/actions/cartAction";
import WorkshopDataItem from "./WorkshopDataItem";

const WorkshopData = ({
  id,
  globalData,
  setShow,
  apiData,
  cart,
  cityFilter,
}) => {
  return apiData.workshopFilterMap != "" ||
    apiData.workshopFilterMap != undefined ? (
    <>
      {cart.workshop && (
        <WorkshopDataItem
          id={id}
          setShow={setShow}
          item={cart.workshop}
          index={0}
        />
      )}

      {cityFilter == 0 &&
      apiData.workshopFilterMap?.filter(
        (item) => globalData.locationData.data.Emirate == item?.EmirateName
      ).length == 0 &&
      !cart.workshop?.Id ? (
        <div
          style={{ height: "100%" }}
          className="d-flex justify-content-center align-items-center no-ws-found"
        >
          <h6>
            Sorry, no workshops found in your location ,<br />
            Please check the map for nearby workshops.
          </h6>
        </div>
      ) : (
        ""
      )}

      {apiData.workshopFilterMap
        ?.sort((a, b) => {
          const hasMyOffer = (obj) => {
            return obj.Offers?.some(
              (offer) =>
                offer?.PromotionId == cart.appliedCartOffers?.PromotionId
            );
          };
          return hasMyOffer(b) - hasMyOffer(a);
        })
        .sort((a, b) => {
          if (a.IsObChoice && !b.IsObChoice) {
            return -1;
          } else if (!a.IsObChoice && b.IsObChoice) {
            return 1;
          } else {
            return 0;
          }
        })
        .map((e, index) => {
          if (cityFilter == 0) {
            if (globalData.locationData.data.Emirate != e.EmirateName) {
              return <></>;
            }
          }
          if (cart.workshop?.Id == e.Id) {
            return <></>;
          }

          return (
            // <div class="island-scroller-box-s2">
            //   <ul class="workshop-block-island-ul">
            <WorkshopDataItem
              id={id}
              setShow={setShow}
              item={e}
              index={index}
              key={index}
            />
            //   </ul>
            // </div>
          );
        })}
    </>
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Skeleton count={2} style={{ width: "55vw", height: "170px" }} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    apiData: state.apiData,
    globalData: state.globalData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getWorkshopsAddonByVariant: (id, vId) => {
      dispatch(getWorkshopsAddonByVariant(id, vId));
    },
    getWorkshopsJourneyVariant: (id, cId, mId) => {
      dispatch(getWorkshopsJourneyVariant(id, cId, mId));
    },
    getWorkshopsProductCategory: (id, mId) => {
      dispatch(getWorkshopsProductCategory(id, mId));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setCartWorkshop: (data) => {
      dispatch(setCartWorkshop(data));
    },
    setCartJobItems: (data) => {
      dispatch(setCartJobItems(data));
    },
    addToCart: (workshopId, variant, carModeId) => {
      dispatch(addToCart(workshopId, variant, carModeId));
    },
    getCategory: () => {
      dispatch(getCategory());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkshopData);
